import { AxiosHeaders } from 'axios';

import { UploadAttachmentPayload, UploadDataDetails } from '../../src/api/api';
import RestAPI from '../../src/api/restApi';
import { Codeowners } from '../../src/consts/codeowners';
import { catchNetworkExceptions, mapNetworkStatuses } from '../../src/utils/exception';
import { LeadCaptureCreatePayload, LeadCaptureSettingsResponse } from '../types/types';

const prepareHeaders = (token?: string) => {
  const headers = new AxiosHeaders();
  headers.set('Authorization', `Token token=${token}`);
  return headers;
};

export const fetchLeadCaptureSettings = (token?: string) => {
  return catchNetworkExceptions(
    () =>
      RestAPI.getWithHeaders<LeadCaptureSettingsResponse>('/api/lead_capture/embedded/settings', prepareHeaders(token)),
    Codeowners.CUSTOMER_INTAKE,
    mapNetworkStatuses
  );
};

export const createLead = (token: string, values: LeadCaptureCreatePayload) => {
  return catchNetworkExceptions(
    () =>
      RestAPI.postWithCustomHeaders<unknown, LeadCaptureCreatePayload>(
        `/api/lead_capture/embedded/leads`,
        prepareHeaders(token),
        values
      ),
    Codeowners.CUSTOMER_INTAKE,
    mapNetworkStatuses
  );
};

export const getUploadData = ({ mimeType, token }: { token: string; mimeType: string }) => {
  return catchNetworkExceptions(
    () =>
      RestAPI.postWithCustomHeaders<UploadDataDetails, UploadAttachmentPayload>(
        '/api/lead_capture/embedded/lead_attachments',
        prepareHeaders(token),
        {
          content_type: mimeType,
        }
      ),
    Codeowners.CUSTOMER_INTAKE,
    mapNetworkStatuses
  );
};
